import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";

const useStyles = makeStyles((theme) => ({
  buttonProceed: {
    cursor: "pointer",
    borderRadius: "50%",
    width: 60,
    height: 60,
    backgroundColor: "#31BE00",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    "&:hover": {
      backgroundColor: "#3ef000",
    },
    [theme.breakpoints.down("xs")]: {
      width: 50,
      height: 50,
    },
  },
  buttonActive: {
    cursor: "pointer",
    borderRadius: "50%",
    width: 60,
    height: 60,
    backgroundColor: "#FF0000",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  buttonEnabled: {
    cursor: "pointer",
    borderRadius: "50%",
    width: 60,
    height: 60,
    backgroundColor: "#7B0000",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    "&:hover": {
      backgroundColor: "#FF0000",
    },
  },
  buttonActiveBlue: {
    cursor: "pointer",
    borderRadius: "50%",
    width: 60,
    height: 60,
    backgroundColor: "#A8DADC",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  buttonEnabledBlue: {
    cursor: "pointer",
    borderRadius: "50%",
    width: 60,
    height: 60,
    backgroundColor: "#457B9D",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    "&:hover": {
      backgroundColor: "#A8DADC",
    },
  },
  buttonDisabled: {
    borderRadius: "50%",
    width: 60,
    height: 60,
    backgroundColor: "#777777",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  buttonNav: {
    borderRadius: "50%",
    width: 51,
    height: 51,
    backgroundColor: "#7B0000",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    cursor: "pointer",
  },
  icon: {
    width: 40,
    height: 40,
    margin: 10,
  },
  navIcon: {
    width: 30,
    height: 30,
    margin: 10,
  },
  iconSmall: {
    width: 30,
    height: 30,
    margin: 15,
    [theme.breakpoints.down("xs")]: {
      margin: 12,
    },
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
}));

const CustomIconButton = ({
  image,
  Icon,
  onClick,
  active,
  label,
  proceed,
  blue,
  disabled,
  nav,
  id,
}) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handlePopoverOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        className={
          active
            ? blue
              ? classes.buttonActiveBlue
              : classes.buttonActive
            : proceed
            ? classes.buttonProceed
            : blue
            ? classes.buttonEnabledBlue
            : disabled
            ? classes.buttonDisabled
            : nav
            ? classes.buttonNav
            : classes.buttonEnabled
        }
        onClick={onClick}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        id={id ? id : null}
      >
        {image ? (
          <img
            className={
              proceed ? classes.iconSmall : nav ? classes.navIcon : classes.icon
            }
            src={image}
            alt={"Icon"}
          />
        ) : (
          <Icon
            className={
              proceed ? classes.iconSmall : nav ? classes.navIcon : classes.icon
            }
            style={{ color: "white" }}
          />
        )}
      </div>
      {label && !!anchorEl ? (
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          container={anchorEl.parentNode}
          onClose={handlePopoverClose}
          disableScrollLock
        >
          <Typography> {label} </Typography>
        </Popover>
      ) : null}
    </>
  );
};

export default CustomIconButton;
